/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import UIConstants from "../../UIConstants";
import { environment } from "../environment";
import StringUtil from "./StringUtil";

export function getRedirectPath({ pathname, hash, searchParams }: RedirectUriInit = {}) {
    const url = new URL(window.location.href);
    if (pathname) url.pathname = pathname.startsWith("/") ? pathname : "/" + pathname;
    if (hash) url.hash = hash.startsWith("#") ? hash.slice(1) : hash;
    if (searchParams)
        Object.entries(searchParams).forEach(([k, v]) => url.searchParams.append(k, v));
    return url.pathname + url.search + url.hash;
}

export type RedirectUriInit = {
    // patname - beginnend mit Mandant z. B. /entwicklung/seminar/6A3649FB-F4CB-4CE8-9E61-74DF3E05FEB0
    // Bei Nichtangabe wird der momentane Pfad verwendet
    pathname?: string;

    // hash - Anker der Seite z. B. #test123
    // Das vorangestellte Rautezeichen kann weggelassen werden
    // Bei Nichtagabe ist der hash leer
    hash?: string;

    // searchParams - Objekt mit Schlüssel-Wert-Paaren
    // Bei Nichtagabe ist der Search-String leer
    searchParams?: { [key: string]: string };
};

export function login({ pathname, hash, searchParams }: RedirectUriInit = {}) {
    const mandantKennung = environment.isSystem || StringUtil.isEmpty(environment.mandant) ? "" : environment.mandant
    const params = new URLSearchParams({ redirectUri: getRedirectPath(), mandantKennung });
    window.location.href = `${UIConstants.loginPath}?${params}`;
}

export function register({ pathname, hash, searchParams }: RedirectUriInit = {}) {
    const mandantKennung = environment.isSystem || StringUtil.isEmpty(environment.mandant) ? "" : environment.mandant
    const params = new URLSearchParams({ redirectUri: getRedirectPath(), mandantKennung });
    window.location.href = `${UIConstants.registerPath}?${params}`;
}
